import DateWrapper from '../common/DateWrapper';

function generateEvent(event, start, end) {
  return {
    allDay: false,
    title: event.title,
    start: start.toISOString(),
    end: end.toISOString(),
    desc: event.desc,
    location: event.location
  };
}

function add(base, { days, hours, minutes }) {
  const copy = new DateWrapper(base.toISOString());

  days && copy.set('day', copy.get('day') + days);
  hours && copy.set('hour', copy.get('hour') + hours);
  minutes && copy.set('minute', copy.get('minute') + minutes);

  return copy;
}

function generateDefaultEvents(staticContent) {
  const events = staticContent.defaultEvents;
  const base = new DateWrapper().set('hour', 0).set('minute', 0).set('second', 0);

  return [
    generateEvent(events.one, add(base, { hours: 18 }), add(base, { hours: 21 })),
    generateEvent(
      events.two,
      add(base, { days: 2, hours: 8, minutes: 30 }),
      add(base, { days: 2, hours: 10, minutes: 30 })
    ),
    generateEvent(
      events.three,
      add(base, { days: 4, hours: 10 }),
      add(base, { days: 4, hours: 17 })
    ),
    generateEvent(
      events.four,
      add(base, { days: 5, hours: 17 }),
      add(base, { days: 5, hours: 18 })
    ),
    generateEvent(events.one, add(base, { days: 7, hours: 18 }), add(base, { days: 7, hours: 21 })),
    generateEvent(
      events.two,
      add(base, { days: 9, hours: 8, minutes: 30 }),
      add(base, { days: 9, hours: 10, minutes: 30 })
    )
  ];
}

export { generateDefaultEvents, generateEvent, add };
